/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd. */

export const GET_ALLPRINTERS_REQUEST = "GET_ALLPRINTERS_REQUEST";
export const GET_ALLPRINTERS_SUCCESS = "GET_ALLPRINTERS_SUCCESS";
export const GET_ALLPRINTERS_FAILURE = "GET_ALLPRINTERS_FAILURE";

export const PUT_PRINTERCONFIGURATION_REQUEST =
  "PUT_PRINTERCONFIGURATION_REQUEST";
export const PUT_PRINTERCONFIGURATION_SUCCESS =
  "PUT_PRINTERCONFIGURATION_SUCCESS";
export const PUT_PRINTERCONFIGURATION_FAILURE =
  "PUT_PRINTERCONFIGURATION_FAILURE";
